exports = module.exports = require("../../../node_modules/_css-loader@0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PopoverImg.vue","sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.25.0@css-loader?sourceMap!./~/_vue-loader@9.9.5@vue-loader/lib/style-rewriter.js?id=data-v-feef93a0&scoped=true!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/PopoverImg.vue
// module id = 221
// module chunks = 0